<template>
     <v-navigation-drawer
        v-model="drawer"
        bottom
      >
        <v-list>
          <v-list-item v-for="(item, i) in items" 
                  :key="i" 
                  :value="item" 
                  @click="on_click_item(item.value)">
              <v-list-item start v-if="item.icon" :prepend-icon="item.icon" :title="item.label"> </v-list-item>
              <v-list-item-title v-else v-text="item.label"></v-list-item-title>  
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
</template>

<script>
export default {
    props:{
        items:{
            default: [],
        },
        drawer:{
            default: false,
        }
    },
    methods: {
      on_click_item(v){
       this.$emit("click_item", v);
      }
    },
}
</script>